import { createSlice } from "@reduxjs/toolkit";


const order = createSlice({
  name: "SelectedItem",
  initialState: {
    type: "Pickup",
    orderData: {items: []},
    note: "",
    pre_order_date_and_time: null,
    isLoading: false,
    replaceItem: null,
  },
  reducers: {
    updateOrderType: (state, action) => {
      state.type = action.payload;
      return state;
    },
    setOrderData: (state, action) => {
      state.orderData = action.payload;
      return state;
    },
    markAsPaid: (state, action) => {
      if (state.orderData?.id == action.payload?.id) {
        state.orderData.payment_status = "paid";
        const currentPayment = state.orderData.payment || {};
        const incomingPayment = action.payload?.payment || {};
        state.orderData.payment = {
          ...currentPayment,
          ...incomingPayment,
          amount: action.payload?.amount ?? incomingPayment.amount ?? currentPayment.amount,
          pay_amount: currentPayment.pay_amount ?? incomingPayment.pay_amount ?? action.payload?.pay_amount ?? action.payload?.amount,
          change_amount: currentPayment.change_amount ?? incomingPayment.change_amount ?? action.payload?.change_amount ?? 0,
          payment_method: action.payload?.method || incomingPayment.payment_method || currentPayment.payment_method || currentPayment.method || "unknown",
          method: action.payload?.method || incomingPayment.payment_method || currentPayment.method || currentPayment.payment_method || "unknown",
        };
      }
      return state;
    },
    updateOrderCategoryStage: (state, action) => {
      state.orderData.category_stage = action.payload;
      return state;
    },
      
    setCookingTime: (state, action) => {
      state.orderData.cooking_time = action.payload;
      return state;
    },
    // updateOrderType: (state, action) => {
    //   state.orderData.order_type = action.payload;
    //   return state;
    // },
    setNoteData : (state, action) => {
      state.note = action.payload;
      return state;
    },
    setPreOrderDateAndTimeData : (state, action) => {
      state.pre_order_date_and_time = action.payload;
      return state;
    },
    setOrderTotalPrice : (state, action) => {
      if(state.orderData){
        state.orderData.total_price = action.payload;
      }
      return state;
    },
    setTipData : (state, action) => {
      if(state.orderData){
        state.orderData.tips = action.payload.tips;
        state.orderData.tips_amount = action.payload.tips_amount;
        state.orderData.total_tips_amount = action.payload.total_tips_amount ?? action.payload.tips_amount;
        state.orderData.tip_type = action.payload.tip_type;
        if (action.payload.tips_mode !== undefined) {
          state.orderData.tips_mode = action.payload.tips_mode;
        }
        if (action.payload.tips_breakdown !== undefined) {
          state.orderData.tips_breakdown = action.payload.tips_breakdown;
        }
      }
      return state;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
      return state;
    },
    setReplaceItemState: (state, action) => {
      state.replaceItem = action.payload;
      return state;
    },
  },
});

export const { updateOrderType, setOrderData, updateOrderCategoryStage, setCookingTime, setNoteData, setPreOrderDateAndTimeData, setOrderTotalPrice, setTipData, setIsLoading, setReplaceItemState, markAsPaid } = order.actions;
export default order.reducer;
